import { combineReducers } from 'redux';

import app from './app';
import nav from './nav';
import prefs from './prefs';

const rootReducer = combineReducers({
  app,
  nav,
  prefs,
})

export default (state, action) => rootReducer(state, action);
